var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ul', {
    staticClass: "radio-list"
  }, _vm._l(_vm.steps, function (step, index) {
    return _c('li', {
      key: index,
      staticClass: "radio-label"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.selected,
        expression: "selected"
      }],
      attrs: {
        "type": "radio",
        "name": step.text
      },
      domProps: {
        "value": step,
        "checked": _vm._q(_vm.selected, step)
      },
      on: {
        "change": [function ($event) {
          _vm.selected = step;
        }, _vm.handleSelect]
      }
    }), _c('label', {
      staticClass: "label"
    }, [_vm._v(_vm._s(step.text))])]);
  }), 0);
}
var staticRenderFns = []

export { render, staticRenderFns }